module.exports = __webpack_public_path__ + "static/media/intro.eb5c77e6.png";